<template>
  <ul :class="$style.nav">
    <li
      v-for="item in items"
      :key="item.name"
      :class="{ [$style.listItem]: true, [$style.spaceAfter]: item.spaceAfter }"
    >
      <router-link :to="item.to" custom>
        <template #default="{ href, navigate, isActive }">
          <a
            :class="[$style.item, $style.link, { [$style.inactiveLink]: isActive }]"
            :data-qa="item.name"
            :href="href"
            @click="navigate"
          >
            <base-icon v-if="item.isLocked" type="unavailable" :class="$style.lock" />
            <span> {{ item.text }} </span>
          </a>
        </template>
      </router-link>
    </li>
  </ul>
</template>

<script>
import BaseIcon from '@/components/icon.vue';

export default {
  name: 'BaseNav',
  components: { BaseIcon },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
</script>

<style module lang="less">
@import '~@less/common/variables';

.nav {
  list-style: none;
  margin: 0;
  padding: 18px 36px 0 0;
}
.listItem {
  border-bottom: 1px solid #eaeaea;
}
.spaceAfter + .listItem {
  margin-top: 28px;
}
.item {
  display: block;
  font-size: 16px;
  line-height: 22px;
  padding: 12px 0 10px;
}
.link {
  color: @linkColor;
  text-decoration: none;
  display: flex;
  align-items: baseline;
  column-gap: 5px;

  &:hover {
    color: @hoverColor;
  }
}
.inactiveLink {
  color: inherit;
  pointer-events: none;
}
.inactiveLink:hover {
  color: inherit;
}

.lock {
  color: white;
  position: relative;
  top: 1px;
  flex-shrink: 0;
}
</style>

<i18n lang="json">{}</i18n>
